module.exports = __webpack_public_path__ + "static/media/NotAllowed.95a307fa.svg";